import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';

import { PaymentService } from '@/api';

import { useConfirmPaymentIntent } from '../../hooks/useConfirmPaymentIntent';

import { useGetPurseRedirectionData } from './useGetPurseRedirectionData';

const CreatePaymentIntent = 'createPaymentIntent';

const useCreatePaymentIntent = ({
  invoiceId,
  onInvoiceAlreadyPaid,
}: {
  invoiceId: string;
  onInvoiceAlreadyPaid: () => Promise<void>;
}) => {
  const { pushErrors } = useToasts();

  const { handleConfirmPaymentIntent } = useConfirmPaymentIntent({
    invoiceId,
    onSuccess: onInvoiceAlreadyPaid,
  });

  const { clientSessionId } = useGetPurseRedirectionData();

  const {
    data: paymentIntentClientSecret,
    isLoading,
    refetch,
  } = useQuery(
    [CreatePaymentIntent, { invoiceId }],
    async () => {
      if (!invoiceId) {
        return undefined;
      }

      const response = await PaymentService.createPaymentIntent({ invoiceId });

      if (response.failure) {
        if (
          response.errors[0].code ===
          'Reverse.Payment.Errors.Payment.CannotPaidTwice'
        ) {
          const response = await handleConfirmPaymentIntent({});

          if (response.failure) {
            pushErrors(response.errors);

            return undefined;
          }

          return;
        }

        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    {
      staleTime: 1_000,
      suspense: true,
      enabled: !clientSessionId,
    },
  );

  return {
    paymentIntentClientSecret: paymentIntentClientSecret,
    isLoading,
    refetch,
  };
};

export default useCreatePaymentIntent;
